<script>
import VueTypes from 'vue-types'

export default {
  name: 'TabItem',

  props: {
    index: VueTypes.string.def('')
  },

  methods: {
    isActiveIndex(index) {
      return this.$attrs.activeindex === index
    },
    updateActiveCategory(index) {
      this.$emit('update-active', index)
    }
  }
}
</script>

<style lang="scss" scoped>
@include iota-breakpoint(md) {
  .tabs__item {
    width: calc(100% / 6.5);
    min-width: calc(100% / 6.5);
    padding: 10px 15px;
    cursor: pointer;
    background-color: rgb(247, 247, 247);
    border: {
      top: 1px solid rgb(177, 177, 177);
      left: 1px solid rgb(177, 177, 177);
    }

    &:last-child {
      margin-right: 40px;
      position: relative;
      border-right: 1px solid rgb(177, 177, 177);

      &::before {
        display: block;
        width: 40px;
        height: 100%;
        content: '';
        background: none;
        background-color: transparent;
        position: absolute;
        right: -40px;
      }
    }

    &::before {
      display: none;
    }

    &.tabs__item--active {
      background-color: #fff;
      position: relative;
      border-bottom: none;

      &::after {
        width: 100%;
        height: 2px;
        content: '';
        background-color: #fff;
        position: absolute;
        bottom: -2px;
        left: 0;
      }
    }

    div {
      flex-grow: 1;
    }

    img {
      height: 45px;
      max-height: 45px;
      max-width: 45px;
    }

    span {
      width: 100%;
      padding-top: 10px;
      text-align: center;
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
